import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './modules/en';
import zh from './modules/zh';

Vue.use(VueI18n);
let i18n = new VueI18n({
    locale: localStorage.getItem('lang') || 'en',
    messages: {
        en,
        zh
    },
    globalInjection: true,
});


export default i18n;